module.exports = __webpack_public_path__ + "img/Templates_W.55ca1660.png";